import React from 'react';
import { motion } from 'framer-motion';
import { Phone, MessageCircle, Send } from 'lucide-react';
export function Contact() {
  const phoneNumber = '095-164-92-45';
  const cleanPhone = '380951649245';
  return <section id="contact" className="py-24 px-6 bg-white border-t border-zinc-100" data-id="element-43">
      <div className="max-w-4xl mx-auto text-center" data-id="element-44">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-45">
          <h2 className="text-4xl md:text-6xl font-semibold tracking-tight text-zinc-900 mb-6" data-id="element-46">
            Почати роботу
          </h2>

          <p className="text-lg text-zinc-500 mb-12 max-w-xl mx-auto font-light" data-id="element-47">
            Зв'яжіться зі мною зручним для вас способом для отримання первинної
            консультації.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-48">
            <a href={`tel:+${cleanPhone}`} className="w-full sm:w-auto flex items-center justify-center gap-3 px-8 py-4 bg-zinc-900 text-white rounded-full font-medium hover:bg-zinc-800 transition-colors" data-id="element-49">
              <Phone className="w-4 h-4" data-id="element-50" />
              Зателефонувати
            </a>

            <a href={`https://wa.me/${cleanPhone}`} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto flex items-center justify-center gap-3 px-8 py-4 bg-white text-zinc-900 border border-zinc-200 rounded-full font-medium hover:bg-zinc-100 transition-colors" data-id="element-51">
              <MessageCircle className="w-4 h-4" data-id="element-52" />
              WhatsApp
            </a>

            <a href={`https://t.me/+${cleanPhone}`} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto flex items-center justify-center gap-3 px-8 py-4 bg-white text-zinc-900 border border-zinc-200 rounded-full font-medium hover:bg-zinc-100 transition-colors" data-id="element-53">
              <Send className="w-4 h-4" data-id="element-54" />
              Telegram
            </a>
          </div>

          <div className="mt-24 pt-8 border-t border-zinc-200 flex flex-col md:flex-row items-center justify-between gap-4 text-zinc-400 text-sm font-light" data-id="element-55">
            <p data-id="element-56">© {new Date().getFullYear()} Всі права захищено.</p>
            <p data-id="element-57">{phoneNumber}</p>
          </div>
        </motion.div>
      </div>
    </section>;
}